export const PREVIEW_MESSAGE = "levami-theme-preview";
export const PREVIEW_READY = "levami-theme-preview-ready";
export const PREVIEW_APPLIED = "levami-theme-preview-applied";
export const PREVIEW_WINDOW_PREFIX = "levami-theme-preview:";

export function previewSession() {
  if (typeof window === "undefined" || window.parent === window) return null;
  const query = new URLSearchParams(window.location.search).get("theme-preview");
  if (query) return query;
  // The iframe name survives internal links and full same-origin page loads.
  return window.name?.startsWith(PREVIEW_WINDOW_PREFIX) ? window.name.slice(PREVIEW_WINDOW_PREFIX.length) : null;
}
